export type FavoriteContentType =
  | "book"
  | "article"
  | "magazine"
  | "kalyan"
  | "kalpataru"
  | "vivekvani"
  | "audio"
  | "pravachan"
  | "dailySatsang"
  | "video";

export type FavoriteAction = "added" | "removed";

const contentLabels: Record<FavoriteContentType, { en: string; hi: string }> = {
  book: { en: "Book", hi: "पुस्तक" },
  article: { en: "Article", hi: "लेख" },
  magazine: { en: "Magazine", hi: "पत्रिका" },
  kalyan: { en: "Kalyan", hi: "कल्याण" },
  kalpataru: { en: "Kalpataru", hi: "कल्पतरु" },
  vivekvani: { en: "Vivek Vani", hi: "विवेक वाणी" },
  audio: { en: "Audio", hi: "ऑडियो" },
  pravachan: { en: "Pravachan", hi: "प्रवचन" },
  dailySatsang: { en: "Daily Satsang", hi: "दैनिक सत्संग" },
  video: { en: "Video", hi: "वीडियो" },
};

const getFavoriteMessage = (type: FavoriteContentType, action: FavoriteAction): string => {
  const isHindi = ["hi", "hindi"].includes((localStorage.getItem("lan") || "").toLowerCase());
  const label = contentLabels[type][isHindi ? "hi" : "en"];

  if (isHindi) {
    return action === "added"
      ? `${label} को पसंदीदा में जोड़ दिया गया है।`
      : `${label} को पसंदीदा से हटा दिया गया है।`;
  }

  return action === "added"
    ? `${label} has been added to favourites.`
    : `${label} has been removed from favourites.`;
};

export const notifyFavoriteMutation = <T,>(
  request: Promise<T>,
  type: FavoriteContentType,
  action: FavoriteAction
): Promise<T> => request.then((response: any) => {
  if (response?.status) {
    window.dispatchEvent(new CustomEvent("favorite-feedback", {
      detail: { message: getFavoriteMessage(type, action) },
    }));
  }
  return response;
});